// store/features/api/billingApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

export const billingApi = createApi({
  reducerPath: "billingApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${BACKEND_API_URL}billing/`,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token || localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["Billing"],
  endpoints: (builder) => ({
    getBillings: builder.query({
      query: (params) => ({
        url: "",
        params,
      }),
      providesTags: ["Billing"],
    }),
    getBilling: builder.query({
      query: (id) => `/${id}`,
      providesTags: ["Billing"],
    }),
    getBillingStats: builder.query({
      query: (params) => ({
        url: "/stats",
        params,
      }),
      providesTags: ["Billing"],
    }),
    addBilling: builder.mutation({
      query: (data) => ({
        url: "",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Billing"],
    }),
    updateBilling: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["Billing"],
    }),
    deleteBilling: builder.mutation({
      query: (id) => ({
        url: `/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Billing"],
    }),
  }),
});

export const {
  useGetBillingsQuery,
  useGetBillingQuery,
  useGetBillingStatsQuery,
  useAddBillingMutation,
  useUpdateBillingMutation,
  useDeleteBillingMutation,
} = billingApi;
